import { Outlet } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorBoundaryFallback } from "../ErrorBoundaryFallback";

export const SafeOutlet = () => {
  return (
    <ErrorBoundary fallback={<ErrorBoundaryFallback />}>
      <Outlet />
    </ErrorBoundary>
  );
};
